import * as React from 'react';
import {Box} from '@mui/material';
import {
  LogoContainer,
  LogoVerticalLine,
} from '../../styles/logoStyle/logoStyle';

const Logo = () => (
  <>
    <LogoContainer>
      <Box
        display="flex"
        justifyContent="center"
        alignItems="center"
        height="100%">
        <img
          src="https://d1iyvy95qprisd.cloudfront.net/Tertulia_logo.png"
          alt=""
        />
      </Box>
    </LogoContainer>
    <LogoVerticalLine />
  </>
);

export default Logo;
